import { useTranslation } from '@mint-lib/i18n';
import { Locked } from '@mint-lib/icons';
import { Button, Card, typographyVariants } from '@mint-lib/tw-components';

type Props = {
  folderName: string;
  onOpenFolder: () => void;
};

const PrivateFolder = ({ folderName, onOpenFolder }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  return (
    <Card
      className="flex h-22 w-67.5"
      contentClassName="flex w-full flex-col gap-4"
      variant={'outlined'}
    >
      <Locked className="size-6 shrink-0 fill-icon-primary" />
      <div className="flex flex-row items-center justify-between">
        <div
          className={typographyVariants({
            variant: 'h6',
            color: 'primary',
          })}
        >
          {folderName}
        </div>
        <Button variant={'outlined'} size={'small'} onClick={onOpenFolder}>
          {t('Open')}
        </Button>
      </div>
    </Card>
  );
};

export { PrivateFolder };
